<app-sentinel-automated-setup (downloadScriptRequested)="downloadScript($event)"></app-sentinel-automated-setup>

<div class="platform-fields" [formGroup]="adapterForm">
  <div class="form-field">
    <label class="required-label">Tenant ID</label>
    <input matInput formControlName="tenantId" placeholder="Enter tenant ID (UUID format)" />
    @if (adapterForm.get('tenantId')?.hasError('invalidUuid') && adapterForm.get('tenantId')?.touched) {
      <small class="error-text">Tenant ID must be in UUID format</small>
    }
  </div>

  <div class="form-field">
    <label class="required-label">Client ID</label>
    <input matInput formControlName="clientId" placeholder="Enter client ID (UUID format)" />
    @if (adapterForm.get('clientId')?.hasError('invalidUuid') && adapterForm.get('clientId')?.touched) {
      <small class="error-text">Client ID must be in UUID format</small>
    }
  </div>

  <div class="form-field">
    <label class="required-label">Client Secret</label>
    <input
      matInput
      type="password"
      formControlName="clientSecret"
      [placeholder]="isEditMode ? '••••••••••••' : 'Enter client secret'"
    />
  </div>

  <div class="form-field">
    <label class="required-label">DCE URI</label>
    <input matInput formControlName="dceUri" placeholder="https://zenity-dce-xyz.eastus-1.ingest.monitor.azure.com" />
    @if (adapterForm.get('dceUri')?.hasError('invalidDceUri') && adapterForm.get('dceUri')?.touched) {
      <small class="error-text">{{ adapterForm.get('dceUri')?.errors?.['invalidDceUri']?.message }}</small>
    }
  </div>

  <div class="form-field">
    <label class="required-label">DCR Immutable ID</label>
    <input matInput formControlName="dcrImmutableId" placeholder="dcr-abc123def456..." />
    @if (
      adapterForm.get('dcrImmutableId')?.hasError('invalidDcrId') && adapterForm.get('dcrImmutableId')?.touched
    ) {
      <small class="error-text">{{ adapterForm.get('dcrImmutableId')?.errors?.['invalidDcrId']?.message }}</small>
    }
  </div>

  <div class="form-field">
    <label class="required-label">Stream Name</label>
    <input matInput formControlName="streamName" placeholder="Custom-ZenityEvents_CL" />
  </div>
</div>
